import script from "./EmailQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./EmailQuestion.vue?vue&type=style&index=0&id=7fc3e348&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc3e348"]])

export default __exports__